export const chartTheme = {
  main: '#00758e',
  secondary: '#865f7f',
};
